<script>
import Vue from "vue"
import numeral from 'numeral'
import moment from 'moment'
import MomentDistance from 'moment.distance';

Vue.filter('numberFormat', function(value) {
	return numeral(value).format("0,0");
});

Vue.filter('decimalFormat', function(value) {
	return numeral(value).format("0,0.00");
});

Vue.filter('shortFormat', function(value) {
	if (value >= 1000) {
		return (numeral(value).format("0.0a")).toUpperCase();	
	} else {
		return numeral(value).format("0,0");
	}
});

Vue.filter('DateFormat', function(value,format) {
	return moment(value).format(format)
});

Vue.filter('DateDistance', function(value) {
	return moment.duration(moment().diff(moment(value))).distance({includeSeconds: false})
});

export default{

}
</script>


// WEBPACK FOOTER //
// src/filters.vue